"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllFileVariantGroupEntryTypes = exports.FileVariantGroupEntryTypes = exports.FileVariantGroupEntryStatus = exports.FileVariantGroupType = void 0;
var FileVariantGroupType;
(function (FileVariantGroupType) {
    FileVariantGroupType["RESIZE"] = "RESIZE";
})(FileVariantGroupType || (exports.FileVariantGroupType = FileVariantGroupType = {}));
var FileVariantGroupEntryStatus;
(function (FileVariantGroupEntryStatus) {
    FileVariantGroupEntryStatus["PENDING"] = "PENDING";
    FileVariantGroupEntryStatus["PROCESSING"] = "PROCESSING";
    FileVariantGroupEntryStatus["COMPLETED"] = "COMPLETED";
    FileVariantGroupEntryStatus["FAILED"] = "FAILED";
})(FileVariantGroupEntryStatus || (exports.FileVariantGroupEntryStatus = FileVariantGroupEntryStatus = {}));
// Entry types per group type
exports.FileVariantGroupEntryTypes = {
    [FileVariantGroupType.RESIZE]: ['9:16', '4:5', '3:4', '1:1', '4:3', '16:9', '1.91:1'],
};
/**
 * Flat array of all possible entry types for Zod validation.
 * Usage: z.enum(AllFileVariantGroupEntryTypes)
 */
exports.AllFileVariantGroupEntryTypes = Object.values(exports.FileVariantGroupEntryTypes).flat();
